import React from "react";

import {
  Backdrop,
  Dialog,
  Card,
  CardHeader,
  CardContent,
  IconButton,
  Slide
} from "@material-ui/core";

import useStyles from "./styles";
import { IoIosClose } from "react-icons/io";
import { useVhListener } from "../../../hooks";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ModalComponent = ({ children, title, open, onClose = () => {} }) => {
  const [{ vhUpdated }] = useVhListener();
  const {
    root,
    paper,
    card,
    cardContent,
    action,
    header,
    titleClass,
    closeButton,
    containerClass
  } = useStyles({ vhUpdated });

  return (
    <Dialog
      fullScreen
      aria-labelledby="modal"
      aria-describedby="modal"
      className={root}
      classes={{ container: containerClass }}
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={() => <Backdrop open={open} />}
      TransitionComponent={Transition}
      BackdropProps={{
        timeout: 500
      }}
    >
      <div className={paper}>
        <Card className={card}>
          <CardHeader
            classes={{ action: action, root: header, title: titleClass }}
            title={title}
            action={
              <IconButton
                aria-label="close"
                className={closeButton}
                onClick={onClose}
              >
                <IoIosClose size={44} />
              </IconButton>
            }
          />
          <CardContent className={cardContent}>{children}</CardContent>
        </Card>
      </div>
    </Dialog>
  );
};

export default ModalComponent;
